export default __webpack_public_path__ + "static/8 - Bojler felújított alaplap-d6a5781dda53ff24e3e166e2acc820c1.jpg";